import { QUERY_KEY } from 'constants/globalConstants'
import DashboardService from 'apiService/dashboardService'
import { useQuery } from 'react-query'

const useClientBreakdown = (order) => {
    return useQuery(QUERY_KEY.GET_CLIENT_BREAKDOWN, ()=>DashboardService.getBreakdown(order), {retry: false})
}

export default useClientBreakdown